
document.addEventListener('DOMContentLoaded', () => {
  //console.log('[DISCOUNT-BINDER] init');

  // Selectors to match whatever your theme uses for apply buttons
  const BUTTON_SELECTORS = [
    '#discount-apply-button',
    '[data-discount-apply]',
    '.discount-apply',
    'button[data-action="apply-discount"]'
  ];
  const BUTTON_SELECTOR = BUTTON_SELECTORS.join(',');

  // Keep track of which buttons we've wired up (avoids double-binding)
  const attached = new WeakSet();

  const shortNode = (n) => {
    if (!n) return null;
    return {
      nodeName: n.nodeName,
      id: n.id || null,
      classes: n.className || null,
      text: (n.innerText || '').slice(0, 80)
    };
  };

  // The click handler logic (per-button). It finds the nearest drawer/footer and uses inputs there.
  const makeHandler = (btn) => {
    return async function handler(ev) {
      try {
        ev.preventDefault();
      } catch(e){ /* some synthetic clicks may not allow preventDefault */ }

      //console.log('[DISCOUNT] clicked', shortNode(btn));

      // Prefer a drawer container, then footer meta block, then fallback to document
      const container =
        btn.closest('.cart-drawer__footer') ||
        btn.closest('.cart-footer-meta--mobile') ||
        btn.closest('.cart-footer') ||
        document;

      //console.log('[DISCOUNT] resolved container:', shortNode(container));

      // Find input + messages *inside the same container* so multiple footers work independently
      const input = container.querySelector('#discount-code-input') || container.querySelector('input[name="discount"]');
      let success = container.querySelector('#discount-success');
      let error = container.querySelector('#discount-error');

      // console.log('[DISCOUNT] found elements', {
      //   input: shortNode(input),
      //   success: shortNode(success),
      //   error: shortNode(error)
      // });

      // If messages do not exist, create minimal placeholders so UI won't crash
      if (!success) {
        success = document.createElement('p');
        success.id = 'discount-success';
        success.className = 'discount-message success';
        success.style.display = 'none';
        container.appendChild(success);
        //console.log('[DISCOUNT] created missing success node');
      }
      if (!error) {
        error = document.createElement('p');
        error.id = 'discount-error';
        error.className = 'discount-message error';
        error.style.display = 'none';
        container.appendChild(error);
        //console.log('[DISCOUNT] created missing error node');
      }

      if (!input) {
        //console.warn('[DISCOUNT] no discount input found in this container; aborting');
        error.textContent = 'Discount input not found.';
        error.style.display = '';
        return;
      }

      const code = input.value.trim();
      success.style.display = error.style.display = 'none';
      //console.log('[DISCOUNT] code value:', JSON.stringify(code));

      if (!code) {
        error.textContent = 'Please enter a discount code.';
        error.style.display = '';
        //console.log('[DISCOUNT] empty code -> shown error');
        return;
      }

      try {
        if(btn){
          btn.textContent = 'Applying...'
        }
        //console.log('[DISCOUNT] sending POST /cart/update.js', { discount: code });
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        });

        //console.log('[DISCOUNT] fetch done, status:', response.status);
        let json = null;
        try { json = await response.json(); } catch (je) { console.warn('[DISCOUNT] no JSON body', je); }

        // console.log('[DISCOUNT] response JSON:', json);
        // NEW LOGIC: check discount_codes
        const appliedCode = json?.discount_codes?.find(dc => 
          dc.code?.toLowerCase() === code.toLowerCase()
        );

        if (!appliedCode || !appliedCode.applicable) {
          const msg = json?.description || 'Invalid or expired discount code';
          if(btn){
            btn.textContent = 'Apply'
          }
          throw new Error(msg);
        }

        success.textContent = 'Discount applied!';
        success.style.display = '';
        if(btn){
          btn.textContent = 'Apply'
        }
        //console.log('[DISCOUNT] applied successfully, dispatching cart:updated');
        document.dispatchEvent(new CustomEvent('cart:updated'));

      } catch (err) {
        //console.error('[DISCOUNT] apply failed:', err);
        error.textContent = err.message || 'Something went wrong.';
        error.style.display = '';
        if(btn){
          btn.textContent = 'Apply'
        }
      }
    };
  };

  // Attach to a single button if not already attached
  const attachButton = (btn) => {
    if (!btn || attached.has(btn)) return;
    //console.log('[ATTACH] wiring up button:', shortNode(btn));
    const handler = makeHandler(btn);
    btn.addEventListener('click', handler);
    // mark attached (WeakSet is enough; also set data attr for debugging / visibility)
    attached.add(btn);
    try { btn.dataset.discountListenerAttached = '1'; } catch(e) {}
  };

  // Scan a root (document or subtree root) and attach to any found buttons
  const scanAndAttach = (root = document) => {
    const found = Array.from(root.querySelectorAll(BUTTON_SELECTOR));
    //if (found.length) console.log('[SCAN] found discount buttons:', found.length);
    found.forEach(attachButton);
  };

  // Initial pass (attach to existing buttons)
  scanAndAttach();

  // MutationObserver: attach to newly added buttons (survives re-renders)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // If nodes were added, scan them (and their subtree) for buttons
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach((node) => {
          try {
            if (node.nodeType !== 1) return;
            // If the added node itself is a button -> attach
            if (node.matches && node.matches(BUTTON_SELECTOR)) {
              attachButton(node);
            }
            // Always scan descendants of the added node
            scanAndAttach(node);
          } catch (err) {
            console.error('[MUTATION] error scanning added node', err, node);
          }
        });
      }

      // Optional: log removals for debug
      if (m.removedNodes && m.removedNodes.length) {
        m.removedNodes.forEach((n) => {
          // no cleanup required thanks to WeakSet, but log for visibility
          //console.log('[MUTATION] removed node', shortNode(n));
        });
      }
    }
  });

  mo.observe(document.body, { childList: true, subtree: true });
  //console.log('[DISCOUNT-BINDER] observer running');
});

document.addEventListener('click', function (e) {
  // Look for label inside .custom-filters
  const label = e.target.closest('.custom-filters label[for^="size-list-desktop-"]');
  if (!label) return;

  const input = label.querySelector('input[name="sort_by"]');
  if (!input) return;

  // Ensure only one checked
  document.querySelectorAll('input[name="sort_by"]').forEach(el => el.checked = false);
  input.checked = true;

  const selectedValue = input.value;
  const url = new URL(window.location.href);
  const params = url.searchParams;

  params.delete('sort_by');
  params.set('sort_by', selectedValue);

  window.history.replaceState({}, '', `${url.pathname}?${params.toString()}`);

  // Emit the filtersUpdated event
  if (typeof window.myComponent?.emit === 'function') {
    window.myComponent.emit('filtersUpdated', {});
  }
});


document.addEventListener('DOMContentLoaded', function () {
  function initTimer(bar) {
    // prevent re-init if already running
    if (bar.dataset.timerInit === "true") return;
    bar.dataset.timerInit = "true";

    const endDate = new Date(bar.dataset.endDate).getTime();
    const showTimer = bar.dataset.showTimer === 'true';
    const countdownEl = bar.querySelector('.annc-countdown-timer');
    const countdownWrapper = countdownEl ? countdownEl.closest('.countdown-wrapper') : null;

    if (!showTimer || !countdownEl) return;
    let timer; // declare before usage

    function updateTimer() {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance <= 0) {
        bar.style.display = 'none'; // Hide banner when expired
        clearInterval(timer);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      countdownEl.innerHTML = `
        <span class="days"><b>${days}</b><span> DAYS</span></span>
        <span class="hours"><b>${hours}</b><span> HOURS</span></span>
        <span class="minutes"><b>${minutes}</b><span> MINUTES</span></span>
        <span class="seconds"><b>${seconds}</b><span> SECONDS</span></span>
      `;

      if (countdownWrapper && countdownWrapper.classList.contains('hidden')) {
        countdownWrapper.classList.remove('hidden');
      }

      bar.style.display = 'flex';
    }

    updateTimer();
    timer = setInterval(updateTimer, 1000);
  }

  // initialize for any timer-bar already present on page
  document.querySelectorAll('.timer-bar').forEach(initTimer);



   // 🔎 MutationObserver for drawer menu updates
  const drawer = document.querySelector(".drawer-menu");
  if (!drawer) return;

  const initDrawerTabs = () => {
    const tabButtons = drawer.querySelectorAll(".drawer-tabs-header .tabs-btn");
    const tabContents = drawer.querySelectorAll(".drawer-tabs-content .tabs-content");

    if (!tabButtons.length || !tabContents.length) return;

    tabButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const target = btn.dataset.content;

        // Remove active from all
        tabButtons.forEach((b) => b.classList.remove("active"));
        tabContents.forEach((c) => c.classList.remove("active"));

        // Add active to clicked
        btn.classList.add("active");
        const targetContent = drawer.querySelector(`#${target}`);
        if (targetContent) {
          targetContent.classList.add("active");
        }
      });
    });
  };

  // Run once on load
  initDrawerTabs();

  function updateFooterMenu (menuDrawer){
    const topMenu = document.querySelector('.topbar-menu-wrapper');
    const footerMenu = menuDrawer.querySelector('.full-second-menu');
    if(footerMenu){
      footerMenu.innerHTML = topMenu?.innerHTML;
    }
  }

  // Watch for drawer-menu being added dynamically
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) {
          const menuDrawer = node.querySelector?.('.drawer-menu__page') || 
                            (node.classList?.contains('drawer-menu__page') ? node : null);

          if (menuDrawer) {
            setTimeout(() => {
              try {
                const timerBar = menuDrawer.querySelector('.timer-bar');
                if (timerBar) {
                  initTimer(timerBar); // only once per bar
                }
                initDrawerTabs();
                window.wishlist?.updateWishlistCount();
                updateFooterMenu(menuDrawer);
              } catch (e) {
                console.error('Error updating drawer-menu:', e);
              }
            }, 100);
          }
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


document.addEventListener("DOMContentLoaded", () => { 
  const carousels = document.querySelectorAll("carousel-component"); 
  carousels.forEach(carousel => { 
    if (carousel.hasAttribute("data-autoplay-mode")) { 
      const nextBtn = carousel.querySelector('[data-direction="next"]'); 
      const prevBtn = carousel.querySelector('[data-direction="prev"]'); 
      const dots = carousel.querySelectorAll("[data-carousel-dot]"); 
      let restartTimeout; 
      const restartAutoplay = () => { 
        clearTimeout(restartTimeout); 
        if (typeof carousel.stop === "function") { 
          carousel.stop(); // Use stop() instead of pause() 
        } 
        restartTimeout = setTimeout(() => { 
          if (typeof carousel.play === "function") { 
            carousel.play(); 
          } 
        }, 30); 
      }; 
      // Handle navigation clicks 
      if (nextBtn) nextBtn.addEventListener("click", restartAutoplay, true); 
      if (prevBtn) prevBtn.addEventListener("click", restartAutoplay, true); 
      
      dots.forEach(dot => { 
        dot.addEventListener("click", restartAutoplay, true); 
      }); 
    } 
  }); 
});

// window.addEventListener("load", function () {
//   document.querySelectorAll(".back-in-stock-btn").forEach((el) => {
//     el.style.opacity = "1";
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  function detectBrowser() {
    const ua = navigator.userAgent.toLowerCase();

    if (/safari/.test(ua) && !/chrome/.test(ua)) {
      return "safari";
    } else if (/chrome|crios/.test(ua) && !/edge|edg/.test(ua)) {
      return "chrome";
    } else if (/firefox|fxios/.test(ua)) {
      return "firefox";
    } else if (/edg/.test(ua)) {
      return "edge";
    } else if (/opr\//.test(ua)) {
      return "opera";
    } else {
      return "unknown";
    }
  }

  const browser = detectBrowser();
  document.body.setAttribute("data-browser", browser);
});



function initCurrencyDropdown() {
  const wrappers = document.querySelectorAll('.topbar-currency-selector-wrapper:not([data-dropdown-init])');

  wrappers.forEach(wrapper => {
    const button = wrapper.querySelector('.topbar-currency-selector');
    const dropdown = wrapper.querySelector('.topbar-currency-dropdown');
    const searchInput = wrapper.querySelector('.tcd-search-wrapper input');

    if (!button || !dropdown) return;

    wrapper.setAttribute('data-dropdown-init', 'true');

    function closeDropdown() {
      wrapper.classList.remove('active');
      button.classList.remove('active');
      dropdown.classList.remove('active');
    }

    // Toggle dropdown open/close
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      const isActive = wrapper.classList.contains('active');

      // Close all other dropdowns
      document.querySelectorAll('.topbar-currency-selector-wrapper.active').forEach(w => {
        if (w !== wrapper) {
          w.classList.remove('active');
          w.querySelector('.topbar-currency-selector')?.classList.remove('active');
          w.querySelector('.topbar-currency-dropdown')?.classList.remove('active');
        }
      });

      if (!isActive) {
        wrapper.classList.add('active');
        button.classList.add('active');
        dropdown.classList.add('active');
        searchInput?.focus();
      } else {
        closeDropdown();
      }
    });

    // ✅ Prevent dropdown from closing when clicking inside the search area
    if (searchInput) {
      searchInput.addEventListener('click', e => {
        e.stopPropagation();
      });

      // ✅ Add search functionality
      searchInput.addEventListener('input', e => {
        const searchValue = e.target.value.toLowerCase().trim();
        const items = wrapper.querySelectorAll('[data-localization-item]');
        items.forEach(item => {
          const text = item.textContent.toLowerCase();
          if (text.includes(searchValue)) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    }

    // Close dropdown when clicking outside (ignore clicks inside dropdown)
    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) {
        closeDropdown();
      }
    });
  });
}

// Run on page load + dynamically via MutationObserver
const observer = new MutationObserver(() => {
  initCurrencyDropdown();
});

observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('DOMContentLoaded', initCurrencyDropdown);



  let searchParams = new URLSearchParams(window.location.search);
  if(searchParams.get('login') == 'success'){
    window.notification = {
      text: "login successful!",
      variant: 'success',
    };
  }


  document.addEventListener('DOMContentLoaded', () => {
    // Desktop: buttons already exist
    function handleWishlistClick() {
      if (window.innerWidth > 768) {
        document.querySelector('#Sidebar-wishlist')?.toggle();
      } else {
        document.querySelector('#AccountMenu')?.hide();
        setTimeout(() => {
          document.querySelector('#Sidebar-wishlist')?.toggle();
        }, 500);
      }
    }

    // Mobile: delegated listener (button is appended later)
    document.addEventListener('click', (event) => {
      const wishlistButton = event.target.closest('[data-wishlist-button]');
      if (!wishlistButton) return;

      handleWishlistClick();
    });

    //
    const links = document.querySelectorAll(`[href="/apps/wishlist"]`) || document.querySelectorAll(`[href="#wishlist"]`);
    //console.log(links)
    links.forEach(element => {
      element.addEventListener('click',(e) => {
        e.preventDefault();
        document.querySelector('#Sidebar-wishlist')?.toggle();
      })
    });
  });

// Loader-state fix: dismiss product-media-grid + product-modal placeholder for eager-loaded images
(function () {
  function markGridLoaded(img) {
    var cell = img.closest('.product-media-grid__item, .product-media-grid--2-column > *, .product-media-grid--1-column > *');
    if (cell) cell.classList.add('is-loaded');
  }
  function markModalLoaded(img) {
    var wrap = img.closest('product-modal-image-wrap, .product-modal__image-wrap');
    if (wrap) wrap.classList.add('is-loaded');
  }
  function attach(img, mark) {
    if (img.complete && img.naturalWidth > 0) {
      mark(img);
    } else {
      img.addEventListener('load', function () { mark(img); }, { once: true });
      img.addEventListener('error', function () { mark(img); }, { once: true });
    }
  }
  function init() {
    var gridImgs = document.querySelectorAll('.product-media-grid img, .product-media-grid--2-column img, .product-media-grid--1-column img');
    gridImgs.forEach(function (img) { attach(img, markGridLoaded); });
    var modalImgs = document.querySelectorAll('product-modal-image-wrap img, .product-modal__image-wrap img');
    modalImgs.forEach(function (img) { attach(img, markModalLoaded); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Also run on Shopify section reload (theme editor / variant swap re-renders)
  document.addEventListener('shopify:section:load', init);
})();



// === Hover swatch image-size fix (v13) ===
// The inline hover-preview script in sections/product.liquid copies the
// swatch thumbnail's srcset onto the main product image on mouseenter.
// The main image has no `sizes` attribute, so the browser falls back to
// 100vw and picks the largest srcset entry (width=4096). The script
// pre-warms variant images at width=1440, but the browser's pick never
// matches that preload — resulting in a ~600-900ms fresh fetch on every
// first hover. Setting `sizes` to the rendered display width forces the
// browser to pick the matching preloaded entry (width=1440 at 688px @ 2x),
// turning hover into an instant cache hit.
(function () {
  function applyFix() {
    if (window.innerWidth < 1024) return;
    var pm = document.querySelector('product-media');
    if (!pm) return;
    var items = pm.querySelectorAll('.product-media-grid__item');
    if (!items || items.length < 2) return;
    var btn = items[1].querySelector('product-modal-button') || items[1];
    var mainImage = btn.querySelector('img');
    if (!mainImage) return;
    function setSizes() {
      var w = mainImage.offsetWidth;
      if (w > 0) {
        mainImage.setAttribute('sizes', w + 'px');
      } else {
        // Retry once the image lays out
        requestAnimationFrame(setSizes);
      }
    }
    setSizes();
    // Re-apply on resize so the picked srcset entry stays right
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setSizes, 150);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFix);
  } else {
    applyFix();
  }
  // Re-apply after section reloads (variant clicks rebuild the gallery)
  document.addEventListener('shopify:section:load', applyFix);
})();
